import type { Friend, MemberContrib } from '@/types'
import { Avatar } from '@/components/ui/Avatar'

interface BalanceBarProps {
  contribs: MemberContrib[]
  currentSteamId: string
}

function fmtH(h: number): string {
  return h < 10 ? h.toFixed(1).replace(/\.0$/, '') : Math.round(h).toString()
}

function contribToFriend(c: MemberContrib, isMe: boolean): Friend {
  return {
    id: c.steamId,
    name: isMe ? 'You' : c.name,
    handle: c.name,
    status: c.private ? 'limited' : 'public',
    hue: c.hue,
    level: '?',
    avatarUrl: c.avatarUrl,
    nickname: null,
  }
}

export function BalanceBar({ contribs, currentSteamId }: BalanceBarProps) {
  const maxH = Math.max(1, ...contribs.map((c) => c.totalH))
  return (
    <div className="cg-balance">
      <div className="cg-balance-header">
        <span className="cg-balance-title">Hours per member</span>
        <div className="cg-balance-legend">
          <span><span className="cg-balance-dot cg-balance-dot-group" />~together</span>
          <span><span className="cg-balance-dot cg-balance-dot-other" />other</span>
        </div>
      </div>
      {contribs.map((c) => {
        const isMe = c.steamId === currentSteamId
        const f = contribToFriend(c, isMe)
        if (c.private) {
          return (
            <div key={c.steamId} className="cg-balance-row" data-private="true">
              <Avatar friend={f} size={20} showRing={false} />
              <span className="cg-balance-name">{isMe ? 'You' : c.name}</span>
              <div className="cg-balance-bar-track">
                <div className="cg-balance-private">private profile — no data</div>
              </div>
              <span className="cg-balance-total">?</span>
            </div>
          )
        }
        const groupPct = (c.groupH / maxH) * 100
        const otherPct = (c.otherH / maxH) * 100
        return (
          <div key={c.steamId} className="cg-balance-row">
            <Avatar friend={f} size={20} showRing={false} />
            <span className="cg-balance-name">{isMe ? 'You' : c.name}</span>
            <div className="cg-balance-bar-track">
              <div className="cg-balance-bar-group" style={{ width: `${groupPct}%` }} title={`~${fmtH(c.groupH)}h together`} />
              <div className="cg-balance-bar-other" style={{ width: `${otherPct}%` }} title={`${fmtH(c.otherH)}h other`} />
            </div>
            <span className="cg-balance-total">
              {fmtH(c.totalH)}h
              <span className="cg-balance-solo-meta"> · ~{fmtH(c.groupH)}h w/ group</span>
            </span>
          </div>
        )
      })}
    </div>
  )
}
